<template>
  <div class="progressbar">
    <div class="progressbar-container">
      <div class="progress" :max="100">
        <div
          class="progressbar__item"
          :style="{ width: progress + '%' }"
          :value="progress"
          :label="`${progress}%`"
        ></div>
      </div>
      <div class="text-right">
        <button
          class="button button--yellow"
          :disabled="!showAnswer"
          @click="next"
        >
          <span v-html="$t('general.next')"></span>
          <span><img :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/de/images/icons/arrow-right.svg`" alt="->" /></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: Number,
    showAnswer: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    next() {
      this.$emit("next-question");
    },
  },
};
</script>

<style scoped lang="scss">
.progressbar {
  position: sticky;
  padding: 1rem 0;
  bottom: 0;
}

.progressbar-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  background: #fff;
  padding: 8px;

  > * + * {
    margin-left: 1rem;
  }
}

.progress {
  display: flex;
  background-color: var(--clr-gray-100);
  overflow: hidden;
  border-radius: 5px;
  height: 4px;
  flex-grow: 1;
}

.progressbar__item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--clr-yellow);
  color: #000;
  overflow: hidden;
}
</style>
